// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal","visible":"visible","background":"background","wrapper":"wrapper","header":"header","cross":"cross","body":"body","addressDetails":"addressDetails","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/Modal/style.scss
// module id = 1209
// module chunks = 0